var React = require('react');

function CartFilledIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.11552 20.6113L5.20423 8.37903H20.5471L18.6358 20.6113H7.11552Z","fill":"#2E2E2E","stroke":"#2E2E2E","strokeWidth":"0.643803","key":0}),React.createElement("path",{"d":"M15.6919 8.86215C15.6919 6.63988 14.6356 4.83838 12.8752 4.83838C11.1148 4.83838 10.0586 6.63988 10.0586 8.86215","stroke":"#2E2E2E","strokeWidth":"0.643803","key":1})]);
}

CartFilledIcon.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = CartFilledIcon;

CartFilledIcon.default = CartFilledIcon;
